/**
 * Returns the correct `emailRedirectTo` / `redirectTo` value for Supabase
 * auth calls based on platform.
 *
 * - Web: uses `window.location.origin` (current behavior preserved exactly).
 * - Native (Capacitor): always returns the canonical web origin so email
 *   confirmation and password-reset links open the website, NOT the
 *   file:// shell of the installed app (which can't host the recovery
 *   token exchange).
 */
import { isNativePlatform } from "@/lib/platform";

const WEB_ORIGIN = "https://lanerunner.com";

export function authRedirectOrigin(): string {
  if (isNativePlatform()) return WEB_ORIGIN;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return WEB_ORIGIN;
}

export function authRedirectUrl(path = "/auth"): string {
  const origin = authRedirectOrigin();
  return `${origin}${path.startsWith("/") ? path : `/${path}`}`;
}
